export function objectContainsFalsyPropsForKeys<T>(sourceObject: T, keys: (keyof T)[]) {
  return keys.some((key: keyof T) => !sourceObject[key]);
}
